import { Image } from '@pata-app/core';
import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import { CallToActionButtons } from '../../../../components/callToActionButtons/callToActionButtons';
import Icon from '../../../../components/icon/icon';
import { FollowUsContainer, LinkContainer, SocialLinksContainer } from './callToAction.styled';

const SOCIAL_LINKS = [
  {
    link: 'https://www.instagram.com/patapet_uk',
    id: 'instagram',
    icon: 'Instagram',
  },
  {
    link: 'https://www.facebook.com/patapetuk',
    id: 'facebook',
    icon: 'Facebook',
  },
  {
    link: 'https://www.linkedin.com/company/pata-pet',
    id: 'linkedin',
    icon: 'Linkedin',
  },
];

export function CallToAction() {
  return (
    <FollowUsContainer>
      <WidthContainer noBackground>
        <h2>Get started with PataPay today</h2>
        <p>
          Join other pet care businesses who are staying ahead of the competition by offering more ways to pay,
          including in-person and online transactions.
        </p>

        <CallToActionButtons />
      </WidthContainer>
    </FollowUsContainer>
  );
}
